/* b2s-text-replace.js — replace "Starter Kit" / "Starter-Kit" with "Snorekit" in rendered text */
(function(){
  'use strict';
  const RULES = [
    { from: /Back2Sleep Starter-Kit/g, to: 'Back2Sleep Snorekit' },
    { from: /Starter-Kit/g, to: 'Snorekit' },
    { from: /Starter Kit/g, to: 'Snorekit' },
    { from: /starter-kit/g, to: 'snorekit' },
    { from: /starter kit/g, to: 'snorekit' },
    { from: /12 products every 12 months/g, to: '12 products for the year' }
  ];

  function replaceTextIn(root) {
    if (!root) return;
    if (root.nodeType === Node.ELEMENT_NODE) {
      const tag = root.tagName ? root.tagName.toLowerCase() : '';
      if (tag === 'script' || tag === 'style' || tag === 'noscript') return;
    }
    if (root.nodeType === Node.TEXT_NODE) {
      let t = root.nodeValue;
      let changed = false;
      for (const r of RULES) {
        if (r.from.test(t)) {
          t = t.replace(r.from, r.to);
          changed = true;
        }
      }
      if (changed) root.nodeValue = t;
      return;
    }
    for (const child of Array.from(root.childNodes || [])) {
      replaceTextIn(child);
    }
  }

  function run() {
    if (!document.body) return;
    replaceTextIn(document.body);
    // Also patch document title
    if (document.title.includes('Starter-Kit') || document.title.includes('Starter Kit')) {
      document.title = document.title.replace(/Starter-Kit/g, 'Snorekit').replace(/Starter Kit/g, 'Snorekit');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  /* Watch for any DOM changes (lazy-loaded sections) and re-run */
  let _t; const observer = new MutationObserver(() => { clearTimeout(_t); _t = setTimeout(run, 120); });
  observer.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
})();

/* ---- sticky scroll-to-top button (site-wide) ---- */
(function () {
  if (window.__b2sScrollTop) return; window.__b2sScrollTop = 1;
  function init() {
    if (!document.body || document.getElementById('b2s-scrolltop')) return;
    var btn = document.createElement('button');
    btn.id = 'b2s-scrolltop';
    btn.type = 'button';
    btn.setAttribute('aria-label', 'Back to top');
    btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 19V6M6 12l6-6 6 6" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    btn.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
    document.body.appendChild(btn);
    var onScroll = function () { btn.classList.toggle('b2s-show', window.scrollY > 600); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
